export default () => {
  /* noOp function */
};
